module.exports = __webpack_public_path__ + "static/Mockup-0c66088cc2b8b671812a0566b1ae608f.png";